module.exports = __webpack_public_path__ + "img/icon_Image_02.a5fbd1d5.png";